import Rest from '@services/Rest'

/**
 * @typedef {SellerScore}
 */
export default class SellerScore extends Rest {
  /**
   * @type {String}
   */
  static resource = '/seller-score'
}
